import { DownOutlined } from '@ant-design/icons'
import { Checkbox, Dropdown, Menu, Space } from 'antd'
import { Button } from 'antd/lib/radio'
import { memo, useState } from 'react'

const CheckboxDropdown = memo(function (props: any) {
  const { value, onChange, options, title } = props
  const [visible, setVisible] = useState(false)

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag)
  }

  return (
    (<Dropdown
      onVisibleChange={handleVisibleChange}
      open={visible}
      overlay={
        <Checkbox.Group value={value} onChange={onChange}>
          <Menu
            items={options.map((item) => ({
              key: item.value,
              label: <Checkbox value={item.value}>{item.label}</Checkbox>
            }))}
          />
        </Checkbox.Group>
      }
      trigger={['click']}
      placement={'bottomRight'}
    >
      <Button>
        <Space>
          {title}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>)
  );
})

export default CheckboxDropdown
